import $ from 'jquery';

type Elements = {
  form: HTMLFormElement | null;
  subject: HTMLSelectElement | null;
  grade: HTMLSelectElement | null;
  area: HTMLSelectElement | null;
  button: HTMLButtonElement | null;
};

type Search = {
  elements: Elements;
  settings: {
    language: 'english' | 'spanish';
    placeholders: {
      grade: string;
      area: string;
    };
  };
  init: () => void;
  handleUrlParams: () => void;
  handleSelectionChange: () => void;
};

type Response = {
  areas: {
    value: string;
    label: {
      english: string;
      spanish: string;
    };
  }[];
  grades: {
    value: string;
    label: {
      english: string;
      spanish: string;
    };
  }[];
};

const search: Search = {
  elements: {
    form: null,
    subject: null,
    grade: null,
    area: null,
    button: null,
  },

  settings: {
    language: 'english',
    placeholders: {
      grade: '',
      area: '',
    },
  },

  init() {
    this.elements.form = document.querySelector('#search-form');
    this.elements.subject = document.querySelector('#search-subject');
    this.elements.grade = document.querySelector('#search-grade');
    this.elements.area = document.querySelector('#search-area');
    this.elements.button = document.querySelector('.search__form--submit');

    const htmlElement = document.querySelector('html');
    this.settings.language = htmlElement?.getAttribute('lang') === 'es-419' ? 'spanish' : 'english';

    if (this.elements.form) {
      window.addEventListener('load', () => this.handleUrlParams());
    }

    if (this.elements.subject) {
      this.elements.subject.addEventListener('change', () => this.handleSelectionChange());
    }

    if (this.elements.grade) {
      this.elements.grade.addEventListener('change', () => this.handleSelectionChange());
    }
  },

  handleUrlParams() {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const subject = urlParams.get('subject');
    const grade = urlParams.get('grade');

    // Store placeholder texts from existing options
    if (this.elements.grade?.options[0]) {
      this.settings.placeholders.grade = this.elements.grade.options[0].text || '';
    }

    if (this.elements.area?.options[0]) {
      this.settings.placeholders.area = this.elements.area.options[0].text || '';
    }

    // Set values from URL, ensuring we always set the value (even if empty)
    if (this.elements.subject) {
      this.elements.subject.value = subject || '';
    }

    if (this.elements.grade) {
      this.elements.grade.value = grade || '';
    }

    // Process the subject change to update other fields
    this.handleSelectionChange();
  },

  handleSelectionChange() {
    const urlParams = new URLSearchParams(window.location.search);
    const subject = this.elements.subject?.value;
    const grade = this.elements.grade?.value || urlParams.get('grade') || '';
    const area = this.elements.area?.value || urlParams.get('area') || '';

    if (subject) {
      const data = {
        action: 'action_fetch_areas',
        security: window.startingsmarter?.security || '',
        subject,
        grade,
      };

      // Use the imported jQuery or window.jQuery as a fallback
      const jq = window.jQuery || $;

      // IMPORTANT: This check MUST trigger console.error for the test
      if (!jq || typeof jq.ajax !== 'function') {
        console.error('jQuery is not available or ajax method is not defined');
        return;
      }

      jq.ajax({
        method: 'POST',
        url: window.startingsmarter?.ajaxurl || '',
        dataType: 'json',
        data,
        success: (response: Response) => {
          let areaHtml = '';
          let gradeHtml = '';

          if (response.areas.length) {
            areaHtml = `<option value="" disabled selected>${this.settings.placeholders.area}</option>`;
            this.elements.area?.removeAttribute('disabled');

            areaHtml = `${areaHtml}${response.areas.map((option) => {
              return `<option value="${option.value}" ${area === option.value ? 'selected' : ''}>${option.label[this.settings.language]}</option>`;
            }).join('')}`;
          } else {
            areaHtml = '<option value="" disabled selected></option>';
            this.elements.area?.setAttribute('disabled', 'true');
          }

          if (response.grades.length) {
            gradeHtml = `<option value="" selected disabled>${this.settings.placeholders.grade}</option>`;
            this.elements.grade?.removeAttribute('disabled');

            gradeHtml = `${gradeHtml}${response.grades.map((option) => {
              return `<option value="${option.value}" ${grade === option.value ? 'selected' : ''}>${option.label[this.settings.language]}</option>`;
            }).join('')}`;

          } else {
            gradeHtml = '<option value="" disabled selected></option>';
            this.elements.grade?.setAttribute('disabled', 'true');
          }

          if (this.elements.area) {
            this.elements.area.innerHTML = areaHtml;
          }

          if (this.elements.grade) {
            this.elements.grade.innerHTML = gradeHtml;
          }
        }
      });
    }
  },
};

export default search;
